import { bool, string } from "prop-types";
import { useMemo } from "react";

import styled from "styled-components/macro";

import {
  useIsLoginDisabled,
  useIsMemberPortal,
} from "CrossFeatureComponents/MemberToolbar/stateHooks";
import FnrTypography from "FnrTypography";

import FnrContainedIcon from "UI/FnrContainedIcon";

const InactiveState = ({ color: colorArg, isLoading }) => {
  const isLoginDisabled = useIsLoginDisabled();
  const isMemberPortal = useIsMemberPortal();

  const color = useMemo(() => {
    if (isLoginDisabled) return "textSecondaryLight";
    return colorArg;
  }, [colorArg, isLoginDisabled]);

  const displayText = useMemo(() => {
    if (isMemberPortal) return "Log In";
    return "Join | Log In";
  }, [isMemberPortal]);

  return (
    <InactiveStateContainer>
      <FnrTypography bold type="copy" color={color} noWrap>
        {displayText}
      </FnrTypography>
      <SFnrContainedIcon
        isLoading={isLoading}
        color={color}
        size="md"
        icon="fa-sign-in fas"
      />
    </InactiveStateContainer>
  );
};

const SFnrContainedIcon = styled(FnrContainedIcon)`
  margin-top: -4px; /* 🤷 */
`;

const InactiveStateContainer = styled.div`
  display: flex;
  align-items: center;
  padding-left: 12px;
  padding-right: 4px;
`;

InactiveState.propTypes = { color: string, isLoading: bool };

export default InactiveState;
